import React from 'react';
import styles from './MBadge.module.css';

interface MBadgeProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  variant?: 'purple-inverse' | 'orange-alert' | 'grey' | 'red' | 'orange' | 'yellow' | 'green' | 'info' | 'prescription' | 'healthMemory' | 'discharge' | string;
}

const MBadge: React.FC<MBadgeProps> = ({ children, className = '', onClick, variant }) => {
  let variantClass = '';
  if (variant === 'purple-inverse') variantClass = styles.purpleInverse;
  else if (variant === 'purple') variantClass = styles.purple;
  else if (variant === 'orange-alert') variantClass = styles.orangeAlert;
  else if (variant === 'grey') variantClass = styles.grey;
  else if (variant === 'red') variantClass = styles.red;
  else if (variant === 'orange') variantClass = styles.orange;
  else if (variant === 'yellow') variantClass = styles.yellow;
  else if (variant === 'green') variantClass = styles.green;
  else if (variant === 'indigo-outline') variantClass = styles.indigoOutline;
  else if (variant === 'info') variantClass = styles.info;
  else if (variant === 'prescription') variantClass = styles.prescription;
  else if (variant === 'healthMemory') variantClass = styles.healthMemory;
  else if (variant === 'discharge') variantClass = styles.discharge;
  return (
    <span
      className={`${styles.mbadge} ${variantClass} ${className}`}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

export default MBadge;
